document.addEventListener("DOMContentLoaded", function() {
	var links = document.querySelectorAll('.nav-link');
	var content = document.querySelectorAll('div.content');
	var border = document.querySelector('span');

	for (let i = 0; i < links.length; i++) {
		links[i].addEventListener('click', function(e) {
			e.preventDefault();
			var activLinks = document.querySelector('.nav-link.activ');
			var activContent = document.querySelector('.tab-pane.activ');

			activLinks.classList.remove('activ');
			activContent.classList.remove('activ');

			this.classList.add('activ');
			var attr = this.getAttribute('href');

			var activ = document.querySelector(attr);
			activ.classList.add('activ');
		});
	}

	jQuery("#nav-1-tab").click(function() {
		jQuery(".change_txt").text("55% more effective");
		jQuery(".kala_th_bar .progress-bar").css("width", "100%");
		jQuery(".oth_bar .progress-bar").css("width", "45%");
	});
	jQuery("#nav-2-tab").click(function() {
		jQuery(".change_txt").text("48% improvement");
		jQuery(".kala_th_bar .progress-bar").css("width", "80%");
		jQuery(".oth_bar .progress-bar").css("width", "42%");
	});
	jQuery("#nav-3-tab").click(function() {
		jQuery(".change_txt").text("50% more reliable");
		jQuery(".kala_th_bar .progress-bar").css("width", "85%");
		jQuery(".oth_bar .progress-bar").css("width", "50%");
	});
});